import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { isEmpty } from "../../helper/helperGeneral";
import { useAuth } from "./../components/authProvider";
import ComLoading from './comLoading';


const RequireAuth = ({ children }) => {
    const { authUser, authLoading } = useAuth();
    const location = useLocation();

    if (authLoading === true) {
        return (
            <section
                className="d-flex flex-column align-items-center justify-content-center text-center bg-light text-dark py-5"
                style={{ minHeight: '60vh' }}
            >
                <ComLoading message="Loading ..." />
            </section>
        );
    }
    else {
        if (isEmpty(authUser)) {
            return <Navigate to="/login" state={{ from: location }} replace />;
        }
        else return children;
    }
};


export default RequireAuth;